import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  wrapper: {
    position: "relative",
    overflow: "hidden",
  },
  thumbnail: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  iframe: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    border: "none",
    opacity: 0,
    transition: "opacity 300ms ease",
  },
  iframeLoaded: {
    opacity: 1,
  },
});
